import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const VerifySuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [status, setStatus] = useState("success");
  const [msg, setMsg] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setStatus(params.get("status") || "success");
    setMsg(params.get("msg") ? decodeURIComponent(params.get("msg")) : "");
    if (params.get("status") === "success") {
      const timer = setTimeout(() => {
        navigate("/login");
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [location, navigate]);

  return (
    <div className="form-container" style={{ textAlign: "center", marginTop: 40 }}>
      <h2>Email Verification</h2>
      {status === "success" ? (
        <>
          <div style={{ fontSize: 32, color: "#008000", marginBottom: 16 }}>✅</div>
          <p style={{ color: "#008000", fontWeight: "bold", fontSize: 18 }}>Email verified! You can now log in.</p>
          <p style={{ marginTop: 16, color: "#555" }}>Redirecting to login...</p>
        </>
      ) : (
        <>
          <div style={{ fontSize: 32, color: "#b30000", marginBottom: 16 }}>❌</div>
          <p style={{ color: "#b30000", fontWeight: "bold", fontSize: 18 }}>Verification failed.</p>
          {msg && <p style={{ color: "#b30000" }}>{msg}</p>}
        </>
      )}
    </div>
  );
};

export default VerifySuccess;
